import './external-tools';
import initializeFoundation from './foundation';
import { initializeAnalytics } from './initializeAnalytics';
import { onReady } from 'boot/common/domReady';
import './setupDatadog';
import './setupHoneybadger';
import './stickySidebar';
import './whatInput';

onReady(initializeAnalytics);

onReady(initializeFoundation);
